import { AU_STRIPE_KEY, GB_STRIPE_KEY, GLOBAL_STRIPE_KEY } from "core/config/config";

export const publicKeys = [
    { country: 'default', key: GLOBAL_STRIPE_KEY },
    { country: 'au', key: AU_STRIPE_KEY },
    { country: 'gb', key: GB_STRIPE_KEY },
];

/**
 * The difference with the above public keys is that AU is the global one and NZ is only for NZ
 * customers.
 */
export const PUBLIC_KEYS_FOR_SHOP_2 = [
    { country: 'default', key: AU_STRIPE_KEY },
    { country: 'nz', key: GLOBAL_STRIPE_KEY },
    { country: 'gb', key: GB_STRIPE_KEY },
];